import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import { IngredientNameInputs } from 'components/desktop/Ingredient/Inputs/IngredientNameInputs';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import PictureBig from 'components/desktop/_general/PictureBig/PictureBig';
import PictureUpload from 'components/desktop/_general/PictureUpload/PictureUpload';
import { getPicturePath } from 'functions/getPicturePath';
import { usePermissions } from 'hooks/usePermissions';

const TabGeneral = (props: IngredientTabProps) => {
	const { isIngredientEditor } = usePermissions();

	return (
		<div className="row mt-4">
			<div className="col-md-4 col-xl-3 col-sm-12 col-12 sidebar">
				<PictureBig path={getPicturePath(props.state.image, 376)} />
				<div className="margin-top-5">
					<RenderIf condition={isIngredientEditor}>
						<PictureUpload setFormData={props.handlers.uploadImage} />
					</RenderIf>
				</div>
			</div>
			<div className="col-md-8 col-xl-9 col-sm-12 col-12">
				<IngredientNameInputs {...props} />
			</div>
		</div>
	);
};

export default TabGeneral;
